import {useMutation} from '@tanstack/react-query';
import {useChekinSDK} from '../context/ChekinSDK';
import {FieldsErrorResponse, LivenessDetection} from '@guestapp/sdk';

type Props = {
  onSuccess?: (data: LivenessDetection) => void;
  onError?: (error: FieldsErrorResponse) => void;
  onSettled?: () => void;
};
function useMutateLivenessDetection({onSuccess, onError, onSettled}: Props) {
  const {livenessDetection} = useChekinSDK();

  return useMutation<LivenessDetection, FieldsErrorResponse, LivenessDetection>(
    variables => livenessDetection(variables),
    {
      onSuccess,
      onError,
      onSettled,
    },
  );
}

export {useMutateLivenessDetection};
